import { computed } from 'vue';
import { useStore } from 'vuex';
import { GetActiveOrganization } from '~/constants/getters';

// this is a temporary solution, we need it for download button
export default () => {
  const store = useStore();

  const novoOrgs = ['zWIQaigZCbX5u5Sz', 'YCKnX53BDtr8yF0A', 'BVSWdPfVtZz3RZH2'];

  const activeOrganization = computed(() => store.getters[`authStore/${GetActiveOrganization}`]);

  const isNotNovoOrg = () => {
    return !novoOrgs.includes(activeOrganization.value?.id);
  };

  return {
    isNotNovoOrg,
  };
};
